import lazysizes from 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import register from 'preact-custom-element'
import 'libs/accessibility'
import 'styles/theme.css'
import 'modules/carousel-swiper/carousel-swiper-custom'
import 'snippets/video-player/video-player'
import 'snippets/accordion-list/accordion-list'
import 'snippets/modal-dialog/modal-dialog'
import 'snippets/notice-main/notice-main'
import 'snippets/read-more/read-more'
import 'snippets/product-recommended/product-recommended'
import 'snippets/product/product-notify/product-notify'
import 'snippets/validate-form/validate-form'
import 'snippets/slideout/slideout'
import 'snippets/newsletter-popup/newsletter-popup'
import 'snippets/form/custom-input-password/custom-input-password'
import NoticeGlobal from 'snippets/notice-global/notice-global'
import QuoteModal from 'snippets/quote/quote-modal'

register(NoticeGlobal, 'notice-global')
register(QuoteModal, 'quote-modal')

lazysizes.init()
